export default __webpack_public_path__ + "static/media/close-circle.e9aed70f.svg";